<template>
  <div ref="el" class="trustpilot-widget" data-locale="en-US" data-template-id="53aa8807dec7e10d38f59f32" data-businessunit-id="5417fd6300006400057a59ec" :data-style-height="height" :data-style-width="width" :data-theme="theme" data-font-family="Nunito">
    <a href="https://www.trustpilot.com/review/www.lendio.com" target="_blank" rel="noopener">
      <span class="signal powered-by-trustpilot">
        <span class="title"></span>
        <NuxtImg :src="fallbackImgUrl" alt="TrustPilot" :width="width" class="mt-2" />
      </span>
    </a>
  </div>
</template>

<script>
import { onMounted, useTemplateRef } from 'vue'

export default {
  name: 'TrustpilotWidget',
  props: {
    width: {
      type: [String, Number],
    },
    height: {
      type: [String, Number],
    },
    theme: {
      type: String,
      default: 'light'
    }
  },
  setup() {
    useHead({
      script: [
        {
          key: 'trustpilot',
          src: "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js",
          async: true,
        }
      ]
    }, { mode: 'client' })

    const el = useTemplateRef('el')

    onMounted(() => {
      // When component is destoyed on initial page and created on another page make sure that we load trustpilot iframe
      if (el.value && window.Trustpilot && !el.value.querySelector('iframe') && window.Trustpilot.loadFromElement) {
        window.Trustpilot.loadFromElement(el.value)
      }
    })
  },
  computed: {
    fallbackImgUrl() {
      const imgName = this.theme === 'light' ? 'trustpilot-logo-new' : 'trustpilot-logo-light'
      return `/images/marketplace/${imgName}.svg`
    }
  }
}
</script>

<style lang="scss" scoped>
.trustpilot-widget {
  min-height: 90px;
  @include media-breakpoint-up(lg) {
    min-height: 75px;
  }
}
span {
  color: $type-500;
}
</style>
